/*
 * @Author: your name
 * @Date: 2020-08-19 16:28:05
 * @LastEditTime: 2020-09-07 18:40:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /backyard-ms/src/views/payroll/config.js
 */
import Vue from 'vue'
import {
  certificateLists, // 员工证明-在职证明、工资证明、就业证明列表
  certificateDown, // 员工证明——在职证明、工资证明、就业证明批量下载
  certificateSend, // 员工证明——在职证明、工资证明、就业证明发送邮件
  sendTawiMail, // 50tawi 全部发送
  countNoEmail, // 证明下载——获取员工空邮箱的数量
  downloadTawiPdf, // 50tawi下载pdf
  previewTawi, // 50tawi预览
  getTawiList
} from 'api/payroll/prove-download'
const $t = Vue.prototype.$t
export const detailData = {
  // 在职证明
  1: {
    title: $t('certificate_staff_1'),
    selectData: {
      left: true, // 左侧筛选模块是否展示
      year: false, // 年份
      drawer: {
        department: true, // 部门
        settlement_type: true, // 结算类型
        formal: true, // 员工属性
        hire_date: true, // 入职日期
        leave_date: false // 离职日期
      }, // 筛选
      input: true, // 输入框
      select: true, // 搜索
      right: true, // 右边按钮模块是否展示
      download: $t('1884'), // 批量下载
      sendAll: false, // 全部发送
      downloadAll: false, // 全部下载,
      selection: true,
      goPath: '/certificate/staff'
    },
    picker: {
      format: 'yyyy',
      type: 'year'
    },
    query: {
      certificate_state: '1', // 1：在职证明，2：工资证明，3：就业证明
      department_id: '', // 部门
      staff_id: '', // 输入框
      settlement_type: '', // 结算类型
      formal: '', // 员工属性
      begin_hire_date: '', // 入职日期
      end_hire_date: '', // 入职日期
      email: '', // 发送邮箱
      page: 1,
      page_size: 100
    },
    api: {
      listData: certificateLists, // 获取列表
      batchDownload: certificateDown, // 批量下载
      sendApi: certificateSend // 发送邮箱
    },
    table: [
      {
        label: $t('22'), // 姓名
        prop: 'staff_name',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('dep_2'), // 英文姓名
        prop: 'staff_name_en',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('25'), // 工号
        prop: 'staff_code',
        align: '',
        width: '120',
        fixed: false
      },
      {
        label: $t('mobile'), // 手机号
        prop: 'mobile',
        align: '',
        width: '192',
        fixed: false
      },
      {
        label: $t('27'), // 部门
        prop: 'department_name',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('24'), // 职位
        prop: 'job_title_name',
        align: '',
        width: '168',
        fixed: false
      },
      {
        label: $t('payroll_salary_24'), // 结算类型
        prop: 'settlement_txt',
        align: '',
        width: '120',
        fixed: false
      },
      {
        label: $t('32'), // 员工属性
        prop: 'formal',
        align: '',
        width: '216',
        fixed: false
      },
      {
        label: $t('28'), // 入职日期
        prop: 'hire_date',
        align: '',
        width: '200',
        fixed: false
      },
      {
        label: $t('70'), // 操作
        prop: '',
        align: '',
        width: '192',
        type: 'operation',
        list: {
          send: $t('225')
        },
        fixed: 'right'
      }
    ]
  },
  // 工资证明
  2: {
    title: $t('certificate_staff_3'),
    selectData: {
      left: true, // 左侧筛选模块是否展示
      year: false, // 年份
      drawer: {
        department: true, // 部门
        settlement_type: true, // 结算类型
        formal: true, // 员工属性
        hire_date: true, // 入职日期
        leave_date: false // 离职日期
      }, // 筛选
      input: true, // 输入框
      select: true, // 搜索
      right: true, // 右边按钮模块是否展示
      download: $t('1884'), // 批量下载
      sendAll: false, // 全部发送
      downloadAll: false, // 全部下载
      selection: true,
      goPath: '/certificate/staff'
    },
    api: {
      listData: certificateLists, // 获取列表
      batchDownload: certificateDown, // 批量下载
      sendApi: certificateSend // 发送邮箱
    },
    picker: {
      format: 'yyyy',
      type: 'year'
    },
    query: {
      certificate_state: '2',
      department_id: '', // 部门
      staff_id: '', // 输入框
      settlement_type: '', // 结算类型
      formal: '', // 员工属性
      begin_hire_date: '', // 入职日期
      end_hire_date: '', // 入职日期
      page: 1,
      page_size: 100
    },
    table: [
      {
        label: $t('22'), // 姓名
        prop: 'staff_name',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('dep_2'), // 英文姓名
        prop: 'staff_name_en',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('25'), // 工号
        prop: 'staff_code',
        align: '',
        width: '120',
        fixed: false
      },
      {
        label: $t('mobile'), // 手机号
        prop: 'mobile',
        align: '',
        width: '192',
        fixed: false
      },
      {
        label: $t('27'), // 部门
        prop: 'department_name',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('24'), // 职位
        prop: 'job_title_name',
        align: '',
        width: '168',
        fixed: false
      },
      {
        label: $t('payroll_salary_24'), // 结算类型
        prop: 'settlement_txt',
        align: '',
        width: '120',
        fixed: false
      },
      {
        label: $t('32'), // 员工属性
        prop: 'formal',
        align: '',
        width: '216',
        fixed: false
      },
      {
        label: $t('28'), // 入职日期
        prop: 'hire_date',
        align: '',
        width: '200',
        fixed: false
      },
      {
        label: $t('70'), // 操作
        prop: '',
        align: '',
        width: '192',
        type: 'operation',
        list: {
          send: $t('225')
        },
        fixed: 'right'
      }
    ]
  },
  // 就业证明
  3: {
    title: $t('certificate_staff_5'),
    selectData: {
      left: true, // 左侧筛选模块是否展示
      year: false, // 年份
      drawer: {
        department: true, // 部门
        settlement_type: true, // 结算类型
        formal: true, // 员工属性
        hire_date: true, // 入职日期
        leave_date: true // 离职日期
      }, // 筛选
      input: true, // 输入框
      select: true, // 搜索
      right: true, // 右边按钮模块是否展示
      download: $t('1884'), // 批量下载
      sendAll: false, // 全部发送
      downloadAll: false, // 全部下载
      selection: true,
      goPath: '/certificate/staff'
    },
    picker: {
      format: 'yyyy',
      type: 'year'
    },
    api: {
      listData: certificateLists, // 获取列表
      batchDownload: certificateDown, // 批量下载
      sendApi: certificateSend // 发送邮箱
    },
    query: {
      certificate_state: '3',
      department_id: '', // 部门
      staff_id: '', // 输入框
      settlement_type: '', // 结算类型
      formal: '', // 员工属性
      begin_hire_date: '', // 入职日期
      end_hire_date: '', // 入职日期
      begin_leave_date: '', // 离职日期
      end_leave_date: '', // 离职日期
      page: 1,
      page_size: 100
    },
    table: [
      {
        label: $t('22'), // 姓名
        prop: 'staff_name',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('dep_2'), // 英文姓名
        prop: 'staff_name_en',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('25'), // 工号
        prop: 'staff_code',
        align: '',
        width: '120',
        fixed: false
      },
      {
        label: $t('mobile'), // 手机号
        prop: 'mobile',
        align: '',
        width: '192',
        fixed: false
      },
      {
        label: $t('27'), // 部门
        prop: 'department_name',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('24'), // 职位
        prop: 'job_title_name',
        align: '',
        width: '168',
        fixed: false
      },
      {
        label: $t('payroll_salary_24'), // 结算类型
        prop: 'settlement_txt',
        align: '',
        width: '120',
        fixed: false
      },
      {
        label: $t('32'), // 员工属性
        prop: 'formal',
        align: '',
        width: '216',
        fixed: false
      },
      {
        label: $t('28'), // 入职日期
        prop: 'hire_date',
        align: '',
        width: '200',
        fixed: false
      },
      {
        label: $t('29'), // 离职日期
        prop: 'leave_date',
        align: '',
        width: '200',
        fixed: false
      },
      {
        label: $t('70'), // 操作
        prop: $t('225'),
        align: '',
        width: '192',
        type: 'operation',
        list: {
          send: $t('225')
        },
        fixed: 'right'
      }
    ]
  },
  // 50 Tawi
  4: {
    title: $t('certificate_staff_7'),
    selectData: {
      left: true, // 左侧筛选模块是否展示
      year: true, // 年份
      drawer: {
        department: true, // 部门
        settlement_type: false, // 结算类型
        formal: false, // 员工属性
        job: true, // 职位
        state: true, // 在职状态
        hire_date: false, // 入职日期
        leave_date: false // 离职日期
      }, // 筛选
      input: true, // 输入框
      select: true, // 搜索
      right: true, // 右边按钮模块是否展示
      download: false, // 批量下载
      sendAll: $t('certificate_staff_13'), // 全部发送
      downloadAll: $t('certificate_staff_11'), // 全部下载
      goPath: '/certificate/staff'
    },
    api: {
      listData: getTawiList, // 获取列表
      allSend: sendTawiMail, // 全部发送
      preview: previewTawi, // 预览
      countEmail: countNoEmail, // 获取员工空邮箱的数量
      allDownload: downloadTawiPdf // 全部下载
    },
    picker: {
      options: true,
      format: 'yyyy',
      type: 'year'
    },
    query: {
      page: 1,
      page_size: 100,
      year: new Date().getFullYear().toString(),
      staff_id: '', // 输入框
      department_id: '', // 部门
      job_title_id: '', // 职位
      state: [] // 结算类型
    },
    table: [
      {
        label: $t('22'), // 姓名
        prop: 'staff_name',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('dep_2'), // 英文姓名
        prop: 'staff_name_en',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('25'), // 工号
        prop: 'staff_code',
        align: '',
        width: '120',
        fixed: false
      },
      {
        label: $t('mobile'), // 手机号
        prop: 'mobile',
        align: '',
        width: '192',
        fixed: false
      },
      {
        label: $t('27'), // 部门
        prop: 'department_name',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('24'), // 职位
        prop: 'job_title_name',
        align: '',
        width: '168',
        fixed: false
      },
      {
        label: $t('state'), // 在职状态
        prop: 'staff_state_text',
        align: '',
        width: '168',
        fixed: false
      },
      {
        label: $t('29'), // 离职日期
        prop: 'leave_date',
        align: '',
        width: '192',
        fixed: false
      },
      {
        label: $t('personal_email'), // 个人邮箱
        prop: 'formal',
        align: '',
        width: '200',
        fixed: false
      },
      {
        label: $t('business_mailbox'), // 企业邮箱
        prop: 'hire_date',
        align: '',
        width: '200',
        fixed: false
      },
      {
        label: $t('70'), // 操作
        prop: $t('225'),
        align: '',
        width: '192',
        type: 'operation',
        list: {
          preview: $t('217'), // 预览
          send: $t('225')
        },
        fixed: 'right'
      }
    ]
  },
  // 定时任务查看
  5: {
    title: $t('1056'),
    selectData: {
      left: true, // 左侧筛选模块是否展示
      year: false, // 年份
      drawer: false, // 筛选
      input: true, // 输入框
      select: true, // 搜索
      right: true, // 右边按钮模块是否展示
      download: false, // 批量下载
      sendAll: false, // 全部发送
      downloadAll: false, // 全部下载
      resend: $t('pay_slip_27'),
      goPath: '/certificate/timing-staff'
    },
    api: {
      listData: certificateLists, // 获取列表
      resend: certificateDown // 批量下载
    },
    query: {
      page: 1,
      page_size: 100,
      certificate_state: 1,
      staff_id: '' // 输入框
    },
    table: [
      {
        label: $t('22'), // 姓名
        prop: 'staff_name',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('27'), // 部门
        prop: 'department_name',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('24'), // 职位
        prop: 'job_title_name',
        align: '',
        width: '168',
        fixed: false
      },
      {
        label: $t('25'), // 工号
        prop: 'staff_code',
        align: '',
        width: '120',
        fixed: false
      },
      {
        label: $t('mobile'), // 手机号
        prop: 'mobile',
        align: '',
        width: '192',
        fixed: false
      },
      {
        label: $t('pay_slip_26'), // 发送状态
        prop: 'mobile',
        align: '',
        width: '168',
        type: 'state',
        fixed: false
      },
      {
        label: $t('certificate_staff_23'), // 发送地址
        prop: 'mobile',
        align: '',
        width: '264',
        type: 'state',
        fixed: false
      },
      {
        label: $t('remark'), // 备注
        prop: 'mobile',
        align: '',
        width: '288',
        type: 'state',
        fixed: false
      },
      {
        label: $t('922'), // 操作人
        prop: 'mobile',
        align: '',
        width: '240',
        type: 'state',
        fixed: false
      },
      {
        label: $t('new_operation_time'), // 操作时间
        prop: 'mobile',
        align: '',
        width: '192',
        type: 'state',
        fixed: false
      },
      {
        label: $t('70'), // 操作
        prop: $t('225'),
        align: '',
        width: '120',
        type: 'operation',
        list: {
          view: $t('64')
        },
        fixed: 'right'
      }
    ]
  },
  // 历史记录
  6: {
    title: $t('certificate_staff_9'),
    selectData: {
      select: true,
      reset: $t('work_rule_7'), // 全部下载
      check: $t('search_btn'),
      goPath: '/certificate/staff'
    },
    api: {
      listData: getTawiList, // 获取列表
      allSend: certificateDown, // 全部发送
      allDownload: certificateDown // 全部下载
    },
    query: {
      page: 1,
      page_size: 100,
      name: ''
    },
    table: [
      {
        label: $t('22'), // 姓名
        prop: 'staff_name',
        align: '',
        width: '240',
        fixed: true
      },
      {
        label: $t('25'), // 工号
        prop: 'staff_code',
        align: '',
        width: '120',
        fixed: false
      },
      {
        label: $t('mobile'), // 手机号
        prop: 'mobile',
        align: '',
        width: '192',
        fixed: false
      },
      {
        label: $t('27'), // 部门
        prop: 'department_name',
        align: '',
        width: '240',
        fixed: false
      },
      {
        label: $t('24'), // 职位
        prop: 'job_title_name',
        align: '',
        width: '168',
        fixed: false
      },
      {
        label: $t('certificate_staff_17'), // 文件类型
        prop: 'mobile',
        align: '',
        width: '168',
        type: 'state',
        fixed: false
      },
      {
        label: $t('certificate_staff_24'), // 文件状态
        prop: 'mobile',
        align: '',
        width: '168',
        type: 'state',
        fixed: false
      },
      {
        label: $t('certificate_staff_23'), // 发送地址
        prop: 'mobile',
        align: '',
        width: '264',
        type: 'state',
        fixed: false
      },
      {
        label: $t('certificate_staff_25'), // 申请人/操作人
        prop: 'mobile',
        align: '',
        width: '240',
        type: 'state',
        fixed: false
      },
      {
        label: $t('206'), // 发送时间
        prop: 'mobile',
        align: '',
        width: '192',
        type: 'state',
        fixed: false
      },
      {
        label: $t('70'), // 操作
        prop: $t('225'),
        align: '',
        width: '120',
        type: 'operation',
        list: {
          view: $t('64')
        },
        fixed: 'right'
      }
    ]
  }
}

export const sendEmail = [
  {
    tit: $t('business_mailbox'),
    icon: require('@/assets/img/icon-email.png'),
    type: 'enterprise_email',
    emalType: '1'
  },
  {
    tit: $t('personal_email'),
    icon: require('@/assets/img/icon-email1.png'),
    type: 'personal_email',
    emalType: '2'
  }
]

export const addTiming = {
  formData: {
    department_list: [],
    staff_list: [],
    staff_info_ids: [],
    department_id: '',
    staff_data: [],
    send_time: '',
    email: '',
    value1: '',
    value2: '',
    value3: '',
    value6: ''
  },
  rules: {
    value1: [{ required: true, message: $t('90'), trigger: 'blur' }],
    value2: [{ required: true, message: $t('221'), trigger: 'change' }],
    value3: [{ required: true, message: $t('221'), trigger: 'change' }],
    staff_data: [{ required: true, message: $t('221'), trigger: 'change' }],
    send_time: [{ required: true, message: $t('221'), trigger: 'change' }],
    email: [{ required: true, message: $t('221'), trigger: 'change' }],
    value6: [{ required: true, message: $t('221'), trigger: 'change' }]
  }
}
